import type { IconDefinition } from '../../types'

export default {
  details: [32, 33, [], '', 'M15.7161 3.44995C15.44 3.44995 15.2161 3.67381 15.2161 3.94995V15.45H3.71615C3.44 15.45 3.21615 15.6738 3.21615 15.95V16.55C3.21615 16.8261 3.44 17.05 3.71615 17.05H15.2161V28.5499C15.2161 28.8261 15.44 29.0499 15.7161 29.0499H16.3161C16.5923 29.0499 16.8161 28.8261 16.8161 28.5499V17.05H28.3161C28.5923 17.05 28.8161 16.8261 28.8161 16.55V15.95C28.8161 15.6738 28.5923 15.45 28.3161 15.45H16.8161V3.94995C16.8161 3.67381 16.5923 3.44995 16.3161 3.44995H15.7161Z'],
  name: 'uiPlusThin',
  oldName: 'culPlusThin'
} as IconDefinition
